var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPlayerSpeed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1321315551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.28014 16H6.67103V8.38621H4.48047V7.25517C5.90027 7.21379 6.58989 7.08966 7.09021 6H8.28014V16Z",
    fill: "#6C6A72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3182 8.57931L13.8302 12.1379L16.4805 16H14.5874L12.8701 13.5034L11.1258 16H9.3544L12.0047 12.2345L9.50314 8.57931H11.3962L12.9512 10.869L14.5604 8.57931H16.3182Z",
    fill: "#6C6A72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 427320252"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 172",
    x1: 0.480469,
    y1: 1.4,
    x2: 8.48047,
    y2: 1.4,
    stroke: "#6C6A72",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 173",
    x1: 10.4805,
    y1: 1.4,
    x2: 15.4805,
    y2: 1.4,
    stroke: "#6C6A72",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 174",
    x1: 17.4805,
    y1: 1.4,
    x2: 20.4805,
    y2: 1.4,
    stroke: "#6C6A72",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 427320253"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 175",
    x1: 0.480469,
    y1: 19.4,
    x2: 8.48047,
    y2: 19.4,
    stroke: "#6C6A72",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 176",
    x1: 10.4805,
    y1: 19.4,
    x2: 15.4805,
    y2: 19.4,
    stroke: "#6C6A72",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 177",
    x1: 17.4805,
    y1: 19.4,
    x2: 20.4805,
    y2: 19.4,
    stroke: "#6C6A72",
    strokeWidth: 1.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayerSpeed);
export default __webpack_public_path__ + "static/media/ic_player_speed.633b969a72eea403148f7e8eaf958e73.svg";
export { ForwardRef as ReactComponent };